import React from 'react';

// Barra de consumo del hotspot de Samsara.
//
// Por que importa y no es decoracion: el Vehicle Gateway trae 500 MB/mes de
// hotspot Wi-Fi y al agotarlo Samsara lo restringe a su propia app de conductor.
// Si el MDVR sale a internet por ese hotspot, llegar al 100% lo deja sin
// plataforma. El 26-sep-2026 habia 9 unidades al tope.
//
// DOS COSAS QUE LA CIFRA NO DICE SOLA:
//
// 1. Satura en el tope: 500.2, 500.5... son unidades que ya lo agotaron, no
//    medidas exactas.
// 2. Puede estar CONGELADA. La fila de Samsara solo se reescribe si su gateway
//    vino en la respuesta, asi que uno que dejo de reportar conserva sus bytes
//    viejos para siempre. El 1-oct-2026 la unidad 82 mostraba "100% agotado" con
//    una cifra del ciclo anterior mientras la 162, ya reiniciada, mostraba 1%:
//    identicas en pantalla, y una de las dos mentia. Por eso el backend manda
//    `lectura_vieja`/`edad_min` y aqui una lectura rancia se pinta en GRIS y sin
//    "agotado" -- esconderla seria peor, es la unica cifra que hay.

export const MB = 1048576;

export const fmtBytes = (n) => {
  if (n == null) return '—';
  if (!n) return '0 B';
  const u = ['B', 'KB', 'MB', 'GB', 'TB'];
  let i = 0, v = n;
  while (v >= 1024 && i < u.length - 1) { v /= 1024; i++; }
  return `${v.toFixed(v < 10 ? 1 : 0)} ${u[i]}`;
};

// Edad en la unidad que se entiende de un vistazo, no en minutos a secas.
export const fmtEdad = (min) => {
  if (min == null) return 'hace rato';
  if (min < 90) return `hace ${Math.round(min)} min`;
  if (min < 48 * 60) return `hace ${Math.round(min / 60)} h`;
  return `hace ${Math.round(min / 1440)} d`;
};

const color = (pct) => (pct >= 99 ? '#dc2626' : pct >= 80 ? '#ea580c' : pct >= 50 ? '#ca8a04' : '#10b981');

const BarraDatos = ({ usados, plan, vieja = false, edadMin = null,
                      compacta = false, mostrarTexto = true }) => {
  if (usados == null || !plan) {
    return <span style={{ color: '#9ca3af', fontSize: 12 }}>—</span>;
  }
  const pct = Math.min(100, (usados * 100) / plan);
  const c = vieja ? '#d1d5db' : color(pct);
  const titulo = vieja
    ? `Sin lectura fresca de Samsara (${fmtEdad(edadMin)}): ${fmtBytes(usados)} de `
      + `${fmtBytes(plan)}. Puede ser del ciclo anterior — ese gateway dejó de `
      + `reportar consumo, y el dato se quedó congelado.`
    : `${fmtBytes(usados)} de ${fmtBytes(plan)} · leído ${fmtEdad(edadMin)}`;
  return (
    <div title={titulo} style={{ minWidth: compacta ? 90 : 150 }}>
      <div style={{
        height: compacta ? 5 : 8, background: '#e5e7eb', borderRadius: 999, overflow: 'hidden',
      }}>
        <div style={{ width: `${pct}%`, height: '100%', background: c, borderRadius: 999 }} />
      </div>
      {mostrarTexto && (
        <div style={{
          fontSize: compacta ? 10 : 11,
          color: vieja ? '#9ca3af' : (pct >= 99 ? c : '#6b7280'),
          marginTop: 2,
        }}>
          {vieja
            ? <>dato viejo · {fmtEdad(edadMin)}</>
            : <>{pct.toFixed(0)}% · {fmtBytes(usados)}{pct >= 99 && <b> · agotado</b>}</>}
        </div>
      )}
    </div>
  );
};

export default BarraDatos;
